import { COMMON_TRANSLATION_KEYS } from "constants/commonTranslationsKeys";
import { ACTION_CREATE, ACTION_DETAILS } from "models/role/action";
import {
  SUBJECT_CASH_MANAGEMENT_VOLT_ACCOUNTS,
  SUBJECT_CLOSED_LOOP_PAYOUTS,
  SUBJECT_OPEN_LOOP_PAYOUTS,
  SUBJECT_REFUND,
} from "models/role/subject";
import { lazyRetryWithPreload } from "utils/lazyRetryWithPreload";

import { PAGE_URLS } from "../constants/PageUrls";

import type { Route } from "routes/RouteModel";

const Payments = lazyRetryWithPreload(
  () => import("../pages/Payments"),
  "Payments"
);

const PaymentNew = lazyRetryWithPreload(
  () => import("../pages/PaymentNew"),
  "PaymentNew"
);

const PaymentDetails = lazyRetryWithPreload(
  () => import("../pages/PaymentDetails"),
  "PaymentDetails"
);

export const accountsPaymentsRoutes: Route[] = [
  {
    title: [COMMON_TRANSLATION_KEYS.payments],
    path: PAGE_URLS.payments,
    component: Payments,
    showChildrenInSidebar: false,
    can: {
      do: ACTION_DETAILS,
      on: SUBJECT_CASH_MANAGEMENT_VOLT_ACCOUNTS,
    },
  },
  {
    path: PAGE_URLS.paymentsNew,
    component: PaymentNew,
    showChildrenInSidebar: false,
    can: {
      or: [
        {
          do: ACTION_CREATE,
          on: SUBJECT_REFUND,
        },
        {
          do: ACTION_CREATE,
          on: SUBJECT_CLOSED_LOOP_PAYOUTS,
        },
        {
          do: ACTION_CREATE,
          on: SUBJECT_OPEN_LOOP_PAYOUTS,
        },
      ],
    },
  },
  {
    path: PAGE_URLS.paymentRefund,
    component: PaymentNew,
    showChildrenInSidebar: false,
    can: {
      do: ACTION_CREATE,
      on: SUBJECT_REFUND,
    },
  },
  {
    title: [COMMON_TRANSLATION_KEYS.paymentDetails],
    path: PAGE_URLS.paymentDetails,
    component: PaymentDetails,
    showChildrenInSidebar: false,
    can: {
      do: ACTION_DETAILS,
      on: SUBJECT_CASH_MANAGEMENT_VOLT_ACCOUNTS,
    },
  },
];
